// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__XUGCt","silent":"Loader_silent__eobqq"};